import type { PaymentProcessor } from "@/react/types/CurrentCommunity";
import { paymentProcessorValidations } from "@circle-react/helpers/paymentProcessorHelpers";
import { PaymentProcessorStatus } from "../constants";

interface UsePaymentProcessorStatusProps {
  paymentProcessor: PaymentProcessor | undefined;
}

interface UsePaymentProcessorStatusReturn {
  paymentProcessorStatus: (typeof PaymentProcessorStatus)[keyof typeof PaymentProcessorStatus];
}

export const usePaymentProcessorStatus = ({
  paymentProcessor,
}: UsePaymentProcessorStatusProps): UsePaymentProcessorStatusReturn => {
  let paymentProcessorStatus:
    | (typeof PaymentProcessorStatus)[keyof typeof PaymentProcessorStatus]
    | undefined = undefined;

  paymentProcessorValidations(paymentProcessor).some(validate => {
    paymentProcessorStatus ||= validate();
  });

  return {
    paymentProcessorStatus:
      paymentProcessorStatus ?? PaymentProcessorStatus.ENABLED,
  };
};
